import { api } from "api/loginRoutes";
import { createAction } from "./defaults";
import {
    E212_SET_LOADING,
    E212_SET_LIST,
    E212_OPERATOR_SET_LIST,
    E212_OPERATOR_DROPDOWN_SET_LIST,
    E212_OPERATOR_DROPDOWN_SET_LOADING,
    E212_COUNTRY_DROPDOWN_SET_LIST,
    E212_COUNTRY_DROPDOWN_SET_LOADING
} from "./actionTypes";
import {
    E212_GET_LIST_API,
    E212_OPERATOR_GET_LIST_API,
    SMS_MCC_COUNTRY_GET_LIST_API,
    SMS_MCC_MNC_GET_DROPDOWN_LIST_API
} from "const/apiMethods";
import { E212 as PREFIX } from "const";

const setLoading = createAction(E212_SET_LOADING);
const setSettingList = createAction(E212_SET_LIST);
const setOperatorList = createAction(E212_OPERATOR_SET_LIST);
const setOperatorDropdownLoading = createAction(E212_OPERATOR_DROPDOWN_SET_LOADING);
const setOperatorDropdownList = createAction(E212_OPERATOR_DROPDOWN_SET_LIST);
const setCountryDropdownLoading = createAction(E212_COUNTRY_DROPDOWN_SET_LOADING);
const setCountryDropdownList = createAction(E212_COUNTRY_DROPDOWN_SET_LIST);

export const getE212List = (filter, page, perPage, sort) => async (dispatch) => {
    dispatch(setLoading(true));

    return await api(E212_GET_LIST_API, { filter, page, per_page: perPage, sort })
        .then((response) => {
            dispatch(setSettingList({
                list: response.e212_e164_list,
                count: response.e212_e164_count,
                page,
                perPage
            }));
        })
        .finally(() => dispatch(setLoading(false)));
};

export const getE212DropdownList = (filter = {}, no_code = false, landline = null) => async (dispatch) => {
    return await api(E212_GET_LIST_API, { filter, no_code, landline })
        .then((response) => {
            dispatch(setSettingList({
                list: response.e212_e164_list,
                count: response.e212_e164_count
            }));
        });
};

export const getE212OperatorList = () => async (dispatch) => {
    return await api(E212_OPERATOR_GET_LIST_API, {})
        .then((response) => {
            dispatch(setOperatorList({
                operator_list: response.operator_list
            }));
        });
};

export const getCountryDropdownList = (filter = {}) => async (dispatch) => {
    dispatch(setCountryDropdownLoading(true));
    return await api(SMS_MCC_COUNTRY_GET_LIST_API, { filter })
        .then((response) => {
            dispatch(setCountryDropdownList({
                country_dropdown_list: response.mcc_list
            }));
        })
        .finally(() => dispatch(setCountryDropdownLoading(false)));
};

export const getOperatorDropdownList = (filter = {}) => async (dispatch) => {
    dispatch(setOperatorDropdownLoading(true));
    return await api(SMS_MCC_MNC_GET_DROPDOWN_LIST_API, { filter })
        .then((response) => {
            dispatch(setOperatorDropdownList({
                operator_dropdown_list: response.mcc_mnc_list
            }));
        })
        .finally(() => dispatch(setOperatorDropdownLoading(false)));
};